<script>
  import CommentBox from "./components/CommentBox.svelte";
  const postPath = window.location.pathname;
  const hostURL = window.location.host;
  export let appUrl;
  export let supabaseUrl;
  export let anonKey;

  const Props = {
    hostURL,
    postPath,
    supabaseUrl,
    anonKey
  };
</script>

{#if hostURL === appUrl}
  <CommentBox {...Props} />
{:else}
  <h1 class="text-6xl text-red-500 p-5">data-url 配置错误</h1>
{/if}

<style>
</style>
